export const documentListConstants = {
  SET_PAGE_SIZE: 'SET_DOCUMENT_PAGE_SIZE',
  DELETE_END: 'DELETE_DOCUMENTS_END',

  SET_RECORDS_REQUEST: 'SET_RECORDS_REQUEST',
  SET_ATTACHMENTS_REQUEST: 'SET_ATTACHMENTS_REQUEST',
  SET_SELECTED_ROWS: 'SET_DOC_SELECTED_ROWS',  
  PRINT_END: 'PRINT_END',
  EXPORT_END: 'EXPORT_END',
};
